export default "__VITE_ASSET__DfLqSMb9__"